import { getObjectGetParams } from 'Lib/get-object-get-params/get-object-get-params';

export const locationSearch = window.location.search.substring(1);

const arGets = locationSearch.length ? locationSearch : [];

export const gets = getObjectGetParams(arGets);